import React from 'react'
import PropTypes from 'prop-types'
import { MicroFrontendLoader } from 'src/views/components/MicroFrontends/MicroFrontendLoader'
import { toPlainSnapshot } from 'src/views/components/MicroFrontends/mfeSnapshot'
import { customerContainer } from 'src/models'
import {
  application,
  isB2BAccount,
  isB2B2C,
  enableCartMFE,
  IS_BROWSER,
} from 'src/utils'
import { pageNames } from 'src/routes/pathParams'

const CartMFE = ({ routerHistory, customerData }) => {
  const shouldRenderCartMFE =
    application?.isTabletOrLarger &&
    (!isB2BAccount() || isB2B2C()) &&
    enableCartMFE() &&
    IS_BROWSER

  if (!shouldRenderCartMFE) {
    return null
  }

  return (
    <div data-testid="qa-mini-cart-mfe">
      <MicroFrontendLoader
        remoteConfig={{
          appName: 'cart-mfe',
          component: 'MiniCart',
        }}
        params={{
          routerHistory,
          // Identity-stable plain snapshot — see mfeSnapshot.js.
          customerData:
            toPlainSnapshot(
              customerData || customerContainer?.profileResponse
            ) || {},
          checkoutPath: pageNames.checkout,
        }}
      />
    </div>
  )
}

CartMFE.propTypes = {
  routerHistory: PropTypes.object.isRequired,
  customerData: PropTypes.object,
}

CartMFE.defaultProps = {
  customerData: null,
}

export default CartMFE
export { CartMFE }
